import React, { useEffect, useState } from "react";
import { Col, Modal, Row, Form } from "react-bootstrap";
// import { Form } from 'react-router-dom';
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "../../API/axios";
import Flatpickr from "react-flatpickr";
import moment from "moment";

const EditExperienceAchivement = ({
  getUserCv,
  userDataId,
  handleCloseEditExperienceAchivement,
  showEditExperienceAchivement,
  experienceData,
  experienceAchivementData,
}) => {
  console.log("experienceAchivementData", experienceAchivementData);
  const sessionId = localStorage.getItem("sessionId");
  const userType = localStorage.getItem("userType");
  const { CandidateId } = useParams();
  const [achievement, setAchievement] = useState("");
  const [achievementtDate, setAchievementDate] = useState("");
  const [display, setDisplay] = useState(false);
  console.log("CandidateId", CandidateId);

    const [formChanged, setFormChanged] = useState(false); // Track if form is modified
    const [isSubmitting, setIsSubmitting] = useState(false);
    // Handle changes and mark form as modified
    const handleFieldChange = (setter, value) => {
      setter(value);
      setFormChanged(true); // Enable Submit button
    };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisplay(true);
    const body = {
      sessionId: sessionId,
      userDataId: userDataId,
      userType: userType,
      instnCnddtID: CandidateId === "Candidate" ? null : CandidateId,
      expId: experienceData.usrDataExpId,
      expAchvmntId: experienceAchivementData.usrDataExpAchvmntId,
      achievement: achievement,
      achivementDate: moment(achievementtDate).format("YYYY-MM-DD"),
    };
    console.log("body", body);
    if (achievement === "" || achievementtDate === "") {
      toast.error("Please fill all the required fields");
      setIsSubmitting(false); // Re-enable the button if validation fails
    } else {
      try {
        const res = await axios.post(
          "/Resume/UpdateExperienceAchievement",
          body
        );
        toast.success(res.data.message);
        handleCloseEditExperienceAchivement();
        getUserCv();
        setDisplay(false);
        setFormChanged(false); // Disable the button after update
      } catch (error) {
        if (error.response && error.response.status === 404) {
          toast.error(error.response.data.message);
        } else {
          toast.error(error.response?.data?.message || "An error occurred");
        }
      } finally {
        setIsSubmitting(false); // Ensure the button is re-enabled in case of failure
      }
    }
  };

  useEffect(() => {
    if (experienceAchivementData) {
      setAchievement(experienceAchivementData.achievement);
      setAchievementDate(experienceAchivementData.achivementDate);
    }
  }, [experienceAchivementData]);

  return (
    <Modal
      show={showEditExperienceAchivement}
      onHide={handleCloseEditExperienceAchivement}
      centered
      size="lg"
    >
      <Modal.Header>
        <Modal.Title>Update experience achievement</Modal.Title>
        <CloseSharpIcon
          className="pointer"
          onClick={handleCloseEditExperienceAchivement}
        />
      </Modal.Header>
      <Modal.Body className="settings">
        <Row>
          <Col md={12} className="mb-2">
            <Form.Group controlId="grade">
              <Form.Label className="class-type">
                Achievement{" "}<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Form.Control
                type="text"
                className=" Dark-Input-from-group"
                value={achievement}
                // onChange={(e) => setAchievement(e.target.value)}
                onChange={(e) => handleFieldChange(setAchievement, e.target.value)} // Track changes
                placeholder="Enter Achievement"
              />
              {display && !achievement ? (
                <span className="error_msg_lbl">Add achievement </span>
              ) : null}
            </Form.Group>
          </Col>
          <Col md={12} className="mb-2">
            <Form.Group controlId="endYear" className=" Flatpickr-Calender-Class">
              <Form.Label className="class-type col-md-12">
                Achievement date{" "}<span style={{ color: "red" }}> *</span>
              </Form.Label>
              <Flatpickr
                type="number"
                value={achievementtDate}
                // onChange={(date) => setAchievementDate(date[0])}
                onChange={(date) => handleFieldChange(setAchievementDate, (date[0]))} // Track changes
                placeholder="Enter Achievement Date"
              // disabled={isPresent}
              options={{
                static: true, // Keeps the calendar visible on click         
              }}
              />
              {display && !achievementtDate ? (
                <span className="error_msg_lbl">Select achievement date </span>
              ) : null}
            </Form.Group>
          </Col>
        </Row>

        <div className="d-flex justify-content-end mt-4">
          <div className="add-class-submit-button mt-4 d-flex justify-content-center">
            <div className="khojPrimaryBtn ms-3"
             onClick={handleSubmit}
             style={{cursor: formChanged ? "pointer" : "default"}}
            >
              <a href="#/"
                // onClick={handleSubmit}
                className={`btn  ${!formChanged || isSubmitting ? "disabled" : "enabled"}`}
                // onClick={!formChanged || isSubmitting ? (e) => e.preventDefault() : handleSubmit}
                disabled={!formChanged || isSubmitting}
                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
              >
                Submit
              </a>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EditExperienceAchivement;
